import React, { Component } from "react";
import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';
import '../css/logs.css';
// import Cookies from 'js-cookie';

class Logs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            logs: ''
        };
    }
    render() {
        const logs = this.props.logs;
        let logsList = [];
        if (this.props.logs) {
            for (let i = 0; i < logs.length; i++) {
                // Compute local time 
                let date = new Date(logs[i].timestamp_UTC + logs[i].timeOffset * 1000 * 60)
                const optionsDate = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
                const optionsTime = { hour: '2-digit', minute: '2-digit' };

                let comment = logs[i].content;
                // comment = comment.replace('\n', '<br />');

                let lat = 0;
                if (typeof (logs[i].lat) == 'number') lat = logs[i].lat.toFixed(2);
                else lat = '?';
                let long = 0;
                if (typeof (logs[i].long) == 'number') long = logs[i].long.toFixed(2);
                else long = '?';

                logsList.push(((<span className="logs_item" key={logs[i].timestamp_UTC}><span className="logs_date">{(date.toLocaleDateString('fr-FR', optionsDate))} ({(date.toLocaleTimeString('fr-FR', optionsTime))})</span>
                    <span className="logs_coords">{lat}, {long}</span>
                    <span className="logs_comment">{comment.split('\n').map((item, key) => {
                        return <span key={key}>{item}<br /></span>
                    })}</span>
                    <span className="logs_delete" onClick={() => this.props.deleteLog(logs[i]._id)}>Supprimer</span></span>)))
            }
        }

        return (
            <div id="logs">
                <div className="logs_head">Journal de bord</div>
                <div id="logs_items">

                    {logsList}

                </div>
                <Formik
                    initialValues={{ logs_text: '' }}
                    validationSchema={Yup.object({
                        logs_text: Yup.string().max(2000)
                    })}
                    onSubmit={(values, actions) => {
                        this.props.createLog(values)
                        actions.resetForm({
                            values: { logs_text: '' },
                        });
                    }}
                >
                    <Form className="logs_form">
                        <Field name="logs_text" as="textarea" placeholder="Notes du capitaine…" className="logs_text" />
                        <button type="submit" className="logs_post">Écrire !</button>
                    </Form>
                </Formik>
            </div>
        );

    }

}

export default Logs;
